import { useState, useEffect, useMemo, useCallback } from "react";
import apiService from "../services/api";
import { isAdmin as checkIsAdmin } from "../utils/permissions";

/**
 * 管理员全景页：拉取普通用户列表，用于按用户折叠展示看板
 */
export function useAdminPanoramaUsers() {
  const [adminUsers, setAdminUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);

  const isAdmin = useMemo(() => {
    try {
      const u = JSON.parse(localStorage.getItem("user") || "{}");
      return checkIsAdmin(u);
    } catch {
      return false;
    }
  }, []);

  const fetchUsers = useCallback(async () => {
    if (!isAdmin) return;
    setLoadingUsers(true);
    try {
      const res = await apiService.users.getUsers({
        page: 1,
        page_size: 100,
        role: "user",
        status: "active",
      });
      const payload = res.data?.data;
      const list = payload?.list ?? payload?.users ?? [];
      setAdminUsers(Array.isArray(list) ? list : []);
    } catch {
      setAdminUsers([]);
    } finally {
      setLoadingUsers(false);
    }
  }, [isAdmin]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  return { isAdmin, adminUsers, loadingUsers, refetchUsers: fetchUsers };
}
